import { ChatPage } from "./components/ChatPage";
import { LoginForm } from "./components/LoginForm";
import { AuthProvider, useAuth } from "./context/AuthContext";

function AuthGate() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="full-page-loading">Loading…</div>;
  }

  return user ? <ChatPage /> : <LoginForm />;
}

export default function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}
